import { Navigate, useLocation } from 'react-router-dom';

import useAuth from './useAuth';

export const TWO_FACTOR_SETUP_PATH = '/zwei-faktor-einrichten';

/**
 * The platform requires 2FA of this account and it has none yet: every page
 * but the setup leads there (the server answers 403 to everything else
 * anyway - SessionGuard, TWO_FACTOR_SETUP_REQUIRED).
 */
export default function TwoFactorGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.twoFactorSetupRequired && location.pathname !== TWO_FACTOR_SETUP_PATH) {
    return (
      <Navigate
        to={TWO_FACTOR_SETUP_PATH}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}
